import { useIconsMap } from "hooks/useIconsMap";

import CardsWrapper from "../CardsWrapper/CardsWrapper";
import Card from "../Card/Card";
import CardText from "../CardText/CardText";

import { useStyles } from "./LocationCard.styles";

const LocationCard = ({ header, streetAddress, zip, city, state, country }) => {
  const {
    locationCardUpperContainer,
    locationCardLowerContainer,
    locationIconContainer,
    locationHeaderContainer,
  } = useStyles();
  const iconsMap = useIconsMap({ style: { fontSize: "50px" } });

  const resolvedLocationText = [city, state, country]
    .filter(Boolean)
    .join(", ");

  return (
    <CardsWrapper>
      <Card
        cardStyles={{
          width: "304px",
          height: "162px",
        }}
      >
        <div className={locationCardUpperContainer}>
          <div className={locationIconContainer}>{iconsMap.locationBlack}</div>
          <div className={locationHeaderContainer}>
            <CardText type="header" text={header} />
          </div>
        </div>
        <div className={locationCardLowerContainer}>
          <CardText
            type="plain"
            text={streetAddress}
            customedStyles={{
              WebkitLineClamp: 2,
              maxHeight: "40px",
            }}
          />
          <CardText
            type="plain"
            text={`PC. ${zip}, ${resolvedLocationText}`}
            customedStyles={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          />
        </div>
      </Card>
    </CardsWrapper>
  );
};

export default LocationCard;
